// Desert Diamonds — global.js
// Minimal global script; custom logic lives in custom.js

// Cart count sync with Shopify
(function () {
  function fetchCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof window.updateCartCount === 'function') {
          window.updateCartCount(cart.item_count);
        } else {
          var badge = document.querySelector('.cart-count');
          if (badge) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'block' : 'none';
          }
        }
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', fetchCartCount);
})();
